/**
 * Calendar cloud setting names
 */
export enum CalendarCloudSettingType {
    ShouldEventsEndEarly = 'Should_Event_End_Early',
    ShortenEventScope = 'shorten_event_scope',
    EndShortEventsBy = 'End_Short_meetings_by',
    EndLongEventsBy = 'End_long_meetings_by',
    EnableOnlineMeetingsByDefault = 'onlinemeetings_enabledbydefault',
    RoamingTimezones = 'roaming_timezones',
    PrimaryTimezoneLabel = 'primary_timezone_label',
    GlobalCalendarEnabled = 'global_calendar_enabled',
    GlobalCalendarLanguage = 'global_calendar_language',
    GlobalCalendarType = 'global_calendar_type',
    RokuyouDays = 'rokuyou_days',
    HijriOffset = 'hijri_offset',
}
